import { AccommodationCategory } from 'proto/Accommodation/AccommodationCategory';

const accommodationCategoryToUrlValueMap: Partial<
    Record<AccommodationCategory, string>
> = {
    [AccommodationCategory.Hotel]: 'hotel',
    [AccommodationCategory.Aparthotel]: 'aparthotel',
    [AccommodationCategory.HolidayHome]: 'holidayhome',
    [AccommodationCategory.HolidayHouse]: 'holidayhouse',
    [AccommodationCategory.BoardingHouse]: 'boardinghouse',
    [AccommodationCategory.BedAndBreakfast]: 'bedandbreakfast',
    [AccommodationCategory.Motel]: 'motel',
    [AccommodationCategory.Hostel]: 'hostel',
    [AccommodationCategory.Camping]: 'camping',
    [AccommodationCategory.Special]: 'special',
};

const urlValueToAccommodationCategoryMap: Partial<
    Record<string, AccommodationCategory>
> = Object.fromEntries(
    Object.entries(accommodationCategoryToUrlValueMap).map(([key, value]) => [
        value,
        key as AccommodationCategory,
    ])
);

export const convertAccommodationCategoryToUrlValue = (
    accommodationCategory: AccommodationCategory
) => accommodationCategoryToUrlValueMap[accommodationCategory];

export const convertUrlValueToAccommodationCategory = (urlValue: string) =>
    urlValueToAccommodationCategoryMap[urlValue];
